export default "/images/a51f824da900caea5e5167e8de3d7f85.avif";